<div class="content">

  <h1 style="color: #2A6ECF;">FLEXSEAT</h1>
  <h1 style="color: #a4a4a4; font-size: 24px ;">Driving the shift to a flexible work solution</h1>
  <h1 style="font-size: 15px ;">Utilize o menu lateral para iniciar.</h1>

  @if(sortedUserReservations.length > 0){

    <div class="reservationList">

      <h1 style="color: #a4a4a4; font-size: 24px ;">Reservas</h1>

      <div class="card-carousel">

        @for(item of sortedUserReservations; track `${item.reservationId}_${$index}`){
          <tds-card [header]="item.tableName" [clickable]="false" [subheader]="'P' +item.building + '-' + item.region"
            [bodyDivider]="true" (tdsClick)="handleCardClick($event)">
            <div slot="body">
              <p>{{item.reservationDate | date:'dd/MM/yyyy'}} </p>

              @if (isToday(item.reservationDate) && !item.checkIn && item.checkInActivated) {
              <tds-button text="Check-In" type="button" variant="primary" size="sm" animation="fade"
                tds-aria-label="A button component" (click)="executeCheckin(item!)">
              </tds-button>
              }

              <tds-button variant="danger" text="Cancelar" size="sm" (click)="cancelReservation(item!)"></tds-button>

            </div>
          </tds-card>
        }

      </div>

    </div>

  }
</div>
